import apiService from '../http.service';
import { appConfig } from '../../app.config';

class TranslationService {

  getTranslations(arrIds) {
    return apiService.post({ 
        query: appConfig.path.GET_TRANSLATIONS, 
        data: {"ids": arrIds} });
  }

  getTranslation(id) {
    return apiService.get({ query: `${appConfig.path.GET_TRANSLATION}?id=${encodeURIComponent(id)}`});
  }

}

export default new TranslationService();



// WEBPACK FOOTER //
// ./src/services/requests/translation.service.js